import * as z from "zod";

export const CheckoutItemInputSchema = z.object({
  product: z.unknown(),
  variantId: z.string().optional().describe("Variant external id. Defaults to the product's first variant."),
  sellingPlanId: z.string().optional().describe("Optional selling plan id for subscription checkout."),
  quantity: z.number().optional().describe("Quantity to checkout. Defaults to 1."),
});

export const CheckoutInputSchema = z.union([CheckoutItemInputSchema, z.array(CheckoutItemInputSchema).min(1)]);
export type CheckoutInput = z.infer<typeof CheckoutInputSchema>;
